const defaultCodeOptionState = {
    modifier : false,
    diagnosis : false,
    procedure : false,
}

const defaultCQAttributes = {
    assessment : true,
    role : true,
}

const defaultMultiUserProject = {
    auditors : []
}

const defaultRubricConfig = {
    rubricId: null as number | null,
    rubricVersionId: null as number | null
}

export const defaultCQAConfig = { ...defaultCQAttributes, ...defaultCodeOptionState, ...defaultMultiUserProject, ...defaultRubricConfig, caseEvaluationLevel: false }


export interface CodeCheckboxField {
    key : string,
    label : string,
    disabled : boolean,
}

export const codeCheckboxes : CodeCheckboxField[] = [ 
    {
        key : 'modifier',
        label : 'Modifier',
        disabled : false,
    },
    {
        key : 'diagnosis',
        label : 'Diagnosis',
        disabled : false,
    },
    {
        key : 'procedure',
        label : 'Procedure',
        disabled : false,
    }
 ]

export const codeEditableCheckboxes : CodeCheckboxField[] = [
    {
        key : 'allow_new_codes',
        label : 'Allow New Codes',
        disabled : false,
    },
 ]

export const attributeCheckboxes : CodeCheckboxField[] = [ 
    {
        key : 'assessment',
        label : 'Assessment',
        disabled : true,
    },
    {
        key : 'role',
        label : 'Role',
        disabled : true,
    }
 ]

 export const evaluationLevelCheckboxes: CodeCheckboxField[] = [
    {
      key : 'caseEvaluationLevel',
      label : 'Case',
      disabled : false,
    }
]

export const multiUserProjectCheckboxes: CodeCheckboxField[] = [
    {
        key : 'isMultiUserProject',
        label : 'Multi-User Project',
        disabled : false,
    }
]